import React, { useLayoutEffect, useRef, useState } from 'react';
import clsx from 'clsx';
import styles from './UIGameFloatingText.module.scss';
import { T } from '@colonist/ui';
import { createPortal } from 'react-dom';
import { useGameStore } from '../../store/GameStoreContext.ts';
import { clamp } from '@colonist/utils';
const FLOAT_DURATION = 1000;
const SCREEN_EDGE_MARGIN = 12;
export const UIGameFloatingText = ({ text, className, direction, children, disabled })=>{
    const { gameOrientation } = useGameStore((state)=>state.gameClientConfig);
    const [floatings, setFloatings] = useState([]);
    const nextAvailableId = useRef(0);
    const containerRef = useRef(null);
    const handleClick = ()=>{
        if (disabled) return;
        const currentId = nextAvailableId.current;
        nextAvailableId.current = nextAvailableId.current + 1;
        setFloatings((prev)=>[
                ...prev,
                currentId
            ]);
        setTimeout(()=>{
            setFloatings((prev)=>prev.filter((id)=>id !== currentId));
        }, FLOAT_DURATION);
    };
    const container = containerRef.current;
    var _container_getBoundingClientRect_x;
    const containterX = (_container_getBoundingClientRect_x = container === null || container === void 0 ? void 0 : container.getBoundingClientRect().x) !== null && _container_getBoundingClientRect_x !== void 0 ? _container_getBoundingClientRect_x : 0;
    var _container_getBoundingClientRect_width;
    const containterWidth = (_container_getBoundingClientRect_width = container === null || container === void 0 ? void 0 : container.getBoundingClientRect().width) !== null && _container_getBoundingClientRect_width !== void 0 ? _container_getBoundingClientRect_width : 0;
    const x = containterX + containterWidth / 2;
    var _container_getBoundingClientRect_y;
    const y = (_container_getBoundingClientRect_y = container === null || container === void 0 ? void 0 : container.getBoundingClientRect().y) !== null && _container_getBoundingClientRect_y !== void 0 ? _container_getBoundingClientRect_y : 0;
    const FloatingTextComponent = gameOrientation === 'portrait' ? FloatingTextMobile : FloatingText;
    return /*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.container, className),
        onClick: handleClick,
        ref: containerRef
    }, children, floatings.map((id)=>/*#__PURE__*/ createPortal(/*#__PURE__*/ React.createElement(FloatingTextComponent, {
            direction: direction,
            text: text,
            x: x,
            y: y
        }), document.body, id)));
};
const getClampedFloatingTextX = (x, textWidth)=>{
    const halfWidth = textWidth / 2;
    const minX = SCREEN_EDGE_MARGIN + halfWidth;
    const maxX = window.innerWidth - SCREEN_EDGE_MARGIN - halfWidth;
    if (minX > maxX) return window.innerWidth / 2;
    return clamp(x, minX, maxX);
};
const FloatingText = ({ direction, text, x, y })=>{
    const floatingTextRef = useRef(null);
    const [adjustedX, setAdjustedX] = useState(x);
    useLayoutEffect(()=>{
        const floatingTextElement = floatingTextRef.current;
        if (floatingTextElement == null) return;
        const textWidth = floatingTextElement.getBoundingClientRect().width;
        setAdjustedX(getClampedFloatingTextX(x, textWidth));
    }, [
        x
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.floatingText, styles[direction]),
        ref: floatingTextRef,
        style: {
            animationDuration: `${FLOAT_DURATION}ms`,
            left: adjustedX,
            top: y
        }
    }, /*#__PURE__*/ React.createElement(T, {
        id: text
    }));
};
const FloatingTextMobile = ({ text })=>/*#__PURE__*/ React.createElement("div", {
        className: styles.floatingTextMobile,
        style: {
            animationDuration: `${FLOAT_DURATION}ms`
        }
    }, /*#__PURE__*/ React.createElement(T, {
        id: text
    }));
